import MUIExpandLess from '@mui/icons-material/ExpandLess'

export const ChevronDown = MUIExpandLess
